import { LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE } from './listingTypePluralHumanNameMapTitle';

export const LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_COUNTS = {
  ...LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE,
  VOLOP: getText('Volunteer Opportunities'),
  GRAD_PROGRAM: getText('Grad Programs'),
};
